// src/pages/Home.tsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import ValueProp from '../components/ValueProp';
import Products from '../components/Products';
import PrivacyTrust from '../components/PrivacyTrust';
import LookingAhead from '../components/LookingAhead';
import Footer from '../components/Footer';
import { Container, SECTION_PADDING } from '../styles/layout';
import JsonData from '../data/data.json';
import { SiteData } from '../types/siteDataTypes';
import StoreCtaCard from '../components/StoreCtaCard';

const CtaSection = styled.section`
  padding: 0 0 ${SECTION_PADDING};
`;

/* ─── Component ──────────────────────────────────────────────────────────────── */

const Home: React.FC = () => {
  const [siteData, setSiteData] = useState<SiteData | null>(null);

  useEffect(() => {
    setSiteData(JsonData as SiteData);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {siteData != null ? (
        <>
          <Header data={siteData.Header} />
          <Products data={siteData.Products} />
          <ValueProp data={siteData.ValueProp} />
          <PrivacyTrust data={siteData.PrivacyTrust} />
          <LookingAhead data={siteData.LookingAhead} />
          <CtaSection>
            <Container>
              <StoreCtaCard
                headline="Ready to try Chot Buddies?"
                tagline="AI companions. Private. Secure. Free to start."
              />
            </Container>
          </CtaSection>
          <Footer />
        </>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default Home;
